import { type Common } from './common.js';
import { type PaginatedQueryOptions } from './models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from './models/pagination/PaginationResponse.type.js';
import type * as StandardNoteSection from './models/standardNoteSection.js';

export class API {
  common: Common;
  baseEndpoint = '/standard-note-sections';

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/standard-note-sections';
  }

  async findAll(): Promise<StandardNoteSection.StandardNoteSection[]> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.getJSON(url);
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<StandardNoteSection.FindAllOptions>
  ): Promise<PaginationResponse<StandardNoteSection.StandardNoteSection>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<StandardNoteSection.StandardNoteSection> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async create(
    values: StandardNoteSection.CreateValues
  ): Promise<StandardNoteSection.StandardNoteSection> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async update(
    id: string,
    values: StandardNoteSection.UpdateValues
  ): Promise<StandardNoteSection.StandardNoteSection> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async remove(id: string): Promise<{ success: true }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }
}
